export default "__VITE_ASSET__DAsD06WN__"